const ONE_SECOND = 1000
const ONE_MINUTE = 60 * ONE_SECOND
const ONE_HOUR = 60 * ONE_MINUTE
const ONE_DAY = 24 * ONE_HOUR

const MOSCOW_TIMEZONE_OFFSET = 3

export { ONE_SECOND, ONE_MINUTE, ONE_HOUR, ONE_DAY, MOSCOW_TIMEZONE_OFFSET }
